import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { Input } from "../../../components/ui/input";
import { API, fileUpload, get, roleTypeOption } from "../../../config";
import SearchSelect from "../../../components/SearchSelect";
import { Button } from "../../../components/ui/button";
import { AddAdminRoleSchema } from "../../../lib/Validation";
import { Switch } from "../../../components/ui/switch";

const AddEditRole = ({
  id,
  toggleShowAddEditRole,
  edit,
  fetchRoleData,
  orgId,
}) => {
  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.GET_ADMIN_ROLE_LIST}/` + id);
      setRoleData(reponse?.data?.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setRoleData(null);
    }
  }

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append("name", value?.name ? value?.name : "");
    formData.append("type", value?.type ? value?.type : "");
    formData.append("status", value?.status ? 1 : 0);

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.GET_ADMIN_ROLE_LIST}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditRole();
        fetchRoleData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        name: roleData?.name,
        type: roleData?.type ? roleData?.type : "",
        status: roleData?.status === 1 ? true : roleData?.status === 0 ? false : true,
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddAdminRoleSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid
      }) => (
        <>
          {loading && <Spin fullscreen={true}/>}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden max-h-[80vh] p-4 border rounded-lg">
              <div className="grid gap-4">
                <div className="grid gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="name">
                      <CustomLabelText
                        required={true}
                        labelText="Name"
                        errorField={errors?.name}
                      />
                    </Label>
                    <Input
                      id="name"
                      type="text"
                      name="name"
                      value={values?.name ? values?.name : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="type">
                      <CustomLabelText
                        required={true}
                        labelText="Type"
                        errorField={errors?.type}
                      />
                    </Label>

                    <div className="relative">
                      <SearchSelect
                        frameworks={roleTypeOption}
                        optionType={"Type"}
                        handleSelect={(e) => {
                          setFieldValue("type", e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.type &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={values?.type}
                      />
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-medium">Active</span>
                      <Switch
                        checked={values?.status}
                        onCheckedChange={(e) => setFieldValue("status", e)}
                        className="data-[state=checked]:bg-webPrimary"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit"  disabled={!isValid}>Save</Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditRole();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditRole;
